import { Stack } from '@mantine/core';
import { Text } from '@repo/foundations';
import type { Section } from '../../utils';
import { toSentenceCase } from '../../utils';
import { ReasoningCollapse } from './ReasoningCollapse';

interface AnalysisSectionProps {
	section: Section;
	isLast: boolean;
}

export function AnalysisSection({ section }: AnalysisSectionProps) {
	return (
		<ReasoningCollapse title={toSentenceCase(section.title)} icon="brain">
			<Stack spacing="xs">
				{section.description && (
					<Text size="sm" color="text/secondary/default">
						{section.description}
					</Text>
				)}
				{section.points.length > 0 && (
					<Stack spacing={0}>
						{section.points.map((point, index) => (
							<Text key={index} size="sm" color="text/secondary/default">
								{point.numbered ? `${index + 1}. ` : '• '}
								{point.text}
							</Text>
						))}
					</Stack>
				)}
				{section.afterPoints && (
					<Text size="sm" color="text/secondary/default">
						{section.afterPoints}
					</Text>
				)}
			</Stack>
		</ReasoningCollapse>
	);
}
